import React from "react";
/*
  Based on the linkedin tracking pixel but should work fine for any pixel that
  just has a unique source.
 */

export const TrackingPixel = props => {
  return React.createElement("img", {
    height: "1",
    width: "1",
    style: {
      display: "none"
    },
    ...props
  });
};